import { render, staticRenderFns } from "./Permissions.vue?vue&type=template&id=45cf0863&"
import script from "./Permissions.vue?vue&type=script&lang=js&"
export * from "./Permissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45cf0863')) {
      api.createRecord('45cf0863', component.options)
    } else {
      api.reload('45cf0863', component.options)
    }
    module.hot.accept("./Permissions.vue?vue&type=template&id=45cf0863&", function () {
      api.rerender('45cf0863', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/accessmanagement/Permissions.vue"
export default component.exports